var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineBankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8333 14.1667V4.83333C32.8333 3.54467 31.7887 2.5 30.5 2.5H4.83333C3.54467 2.5 2.5 3.54467 2.5 4.83333V23.5C2.5 24.7887 3.54467 25.8333 4.83333 25.8333H21.1667",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.5H32.8333",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1665 15.334H16.4998",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1665 20H11.8332",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8335 20.334C25.8335 19.5056 26.5051 18.834 27.3335 18.834H36.0002C36.8286 18.834 37.5002 19.5056 37.5002 20.334V36.0007C37.5002 36.8291 36.8286 37.5007 36.0002 37.5007H27.3335C26.5051 37.5007 25.8335 36.8291 25.8335 36.0007V20.334Z",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8335 32.834H37.5002",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineBankingIcon);
export default __webpack_public_path__ + "static/media/online-banking-icon.4012354285c41cd564a1fe3d4a9f4ca5.svg";
export { ForwardRef as ReactComponent };